export const storeGetters = {
    //store getters
    loggedUser: 'loggedUser',
    communityIdPromise: 'communityIdPromise',
    communityName: 'communityName',
    networkTypePromise: 'networkTypePromise',
    getMainPageOverflow: 'getMainPageOverflow',
    currentCommunityView: 'currentCommunityView',
    salesforceURL: 'salesforceURL',
    salesforceURLRoot: 'salesforceURLRoot',
    routeName: 'routeName',
    isMobileAppBrowser: 'isMobileAppBrowser',
    isAndroidAppBrowser: 'isAndroidAppBrowser',
    isIosAppBrowser: 'isIosAppBrowser',
    routeConfigHideHeader: 'routeConfigHideHeader',
    routeConfigHideFooter: 'routeConfigHideFooter',
    routeConfigHideConcierge: 'routeConfigHideConcierge',
    routeConfigEngagementApp: 'routeConfigEngagementApp',
    isCoreContentLoadingInProgress: "isCoreContentLoadingInProgress",

    //forum token
    forumPromise: 'forumPromise',

    //appSettings getters
    appTheme: 'appTheme',

    //auth getters
    authData: 'authData',
    authFeatureFlag: 'authFeatureFlag',
    isAuthenticated: 'isAuthenticated',
    sessionExpiry: 'sessionExpiry',
    inactiveSessionDetected: 'inactiveSessionDetected',
    authenticatedUserId: 'authenticatedUserId',
    authenticatedUserEmail: 'authenticatedUserEmail',
    passwordRecoveryOptions: 'passwordRecoveryOptions',
    getSelectedCodeRecoveryType: 'getSelectedCodeRecoveryType',
    getSessionToken: 'getSessionToken',
    getTokenExpirationTime: 'getSessionExpirationTime',
    getLoginError: 'getLoginError',
    userRecoveryOptions: 'userRecoveryOptions',
    passwordFurtherAssistance: 'passwordFurtherAssistance',
    getSelectTypePasswordDelivery: 'getSelectTypePasswordDelivery',
    getMemberAdditionalSecurityObject: 'getMemberAdditionalSecurityObject',
    getPostLoginRedirectRoute: 'getPostLoginRedirectRoute',
    isMemberProspect: 'isMemberProspect',
    isChapterManager: 'isChapterManager',
    shouldDefaultToChapterStudioPage: "shouldDefaultToChapterStudioPage",
    canViewChapterStudioPage: 'canViewChapterStudioPage',
    canViewManageChapterStudioPage: 'canViewManageChapterStudioPage',
    isChaptersAndRegionsTeamMember: 'isChaptersAndRegionsTeamMember',
    isYngMember: 'isYngMember',
    paymentRedirectUrl: 'paymentRedirectUrl',
    permissionsData: 'permissionsData',
    userCommunities: 'userCommunities',
    isPendingResignation: 'isPendingResignation',
    isExceptionOccurredOnGetPermissions: 'isExceptionOccurredOnGetPermissions',
    hasConnectAccess: 'hasConnectAccess',
    systemMessages: 'systemMessages',
    cookiesPolicyAccepted: 'cookiesPolicyAccepted',
    isImpersonationMode: 'isImpersonationMode',
    memberAdminControls: 'memberAdminControls',
    tokenRefreshTime: 'tokenRefreshTime',
    isTeamProductManager: 'isTeamProductManager',
    isGroupSuperAdmin: 'isGroupSuperAdmin',

    //ypo Search module getter
    peopleOneClickSearchSuggestions: 'peopleOneClickSearchSuggestions',
    peopleSearchSuggestions: 'peopleSearchSuggestions',
    eventSearchSuggestions: 'eventSearchSuggestions',
    communitySearchSuggestions: 'communitySearchSuggestions',
    contentSearchSuggestions: 'contentSearchSuggestions',

    //YPO Resources
    ypoResources: 'ypoResources',
    hideCategoriesWithExtensiveLinks: 'hideCategoriesWithExtensiveLinks',

    // Ypo Concierge
    ypoConciergeTopics: 'ypoConciergeTopics',
    isYpoConciergeAgentAvailable: 'isYpoConciergeAgentAvailable',
    isConciergeScriptLoaded: 'isConciergeScriptLoaded',
    isConciergeActive: 'isConciergeActive',
    conciergeFeatureFlag: 'conciergeFeatureFlag',
    conciergeUserData: 'conciergeUserData',

    //chapter module getters
    activityFeedList: 'activityFeedList',
    isPostEditing: 'isPostEditing',
    isPostChangePending: 'isPostChangePending',
    userProfile: 'userProfile',
    chairMessage: 'chairMessage',
    chapterMessage: 'chapterMessage',
    isUserMemberOfCommunity: 'isUserMemberOfCommunity',
    getShowMoreCallCountForPost: 'getShowMoreCallCountForPost',
    isHiddenPost: 'isHiddenPost',
    aboutView: 'aboutView',
    chapterAwards: 'chapterAwards',
    featureEvents: 'featureEvents',
    featureEventObject: 'featureEventObject',
    commentedUsers: 'commentedUsers',
    likedUsers: 'likedUsers',
    usersCommunitiesList: 'usersCommunitiesList',
    champsChapters: 'champsChapters',
    getPrimaryChapter: 'getPrimaryChapter',
    chapterOfficersData: 'chapterOfficersData',
    adminFeedList: 'adminFeedList',
    getFileList: 'getFileList',
    transactionHubContent: 'transactionHubContent',
    disableInfiniteScroll: 'disableInfiniteScroll',
    noMoreActivityToFetch: 'noMoreActivityToFetch',
    communityInfo: 'communityInfo',
    chapterQuickLinks: 'chapterQuickLinks',
    isMainActivityFeedHidden: 'isMainActivityFeedHidden',

    //groups
    groupFocusList: 'groupFocusList',
    groupConfigRequest: 'groupConfigRequest',
    pendingRequestList: 'pendingRequestList',
    isLastAdminStatus: 'isLastAdminStatus',
    canEditGroup: 'canEditGroup',
    errorFetchingCommunityData: 'errorFetchingCommunityData',

    // Upcoming Events
    upcomingEventList: 'upcomingEventList',

    //Member Directory Results
    memberDirectorySearchResults: 'memberDirectorySearchResults',
    memberDirectorySort: 'memberDirectorySort',
    memberDirectorySearchText: 'memberDirectorySearchText',
    disableMemberDirectoryInfiniteScroll: 'disableMemberDirectoryInfiniteScroll',
    nextMemberDirectorySearchOffset: 'nextMemberDirectorySearchOffset',
    memberDirectorySelectedLetterFilter: 'memberDirectorySelectedLetterFilter',
    memberResultList: 'memberResultList',
    ribbonState: 'ribbonState',
    selectedMemberDirectoryFilters: 'selectedMemberDirectoryFilters',
    selectedTypeAhead: 'selectedTypeAhead',
    typeAheadForMemberDirectory: 'typeAheadForMemberDirectory',
    selectedFilterKeyForSecondaryOptions: 'selectedFilterKeyForSecondaryOptions',
    subFilterList: 'subFilterList',
    selectedSubFilter: 'selectedSubFilter',
    typeAheadResult: 'typeAheadResult',
    excludedPrivateNetworksList: 'excludedPrivateNetworksList',
    memberConnection: 'memberConnection',
    memberFollow: 'memberFollow',
    memberDirectorySearchKey: 'memberDirectorySearchKey',

    rootFolderCount: 'rootFolderCount',
    //Event Directory Results
    eventDirectorySearchResults: 'eventDirectorySearchResults',
    eventResultList: 'eventResultList',
    eventDirectorySort: 'eventDirectorySort',
    memberVoucherResults: 'memberVoucherResults',
    eventState: 'eventState',
    eventSelectedFilters: 'eventSelectedFilters',
    oneClickDateFilters: 'oneClickDateFilters',
    eventSearchText: 'eventSearchText',
    eventSelectedSubFilter: 'eventSelectedSubFilter',
    eventSelectedTypeAhead: 'eventSelectedTypeAhead',
    typeAheadForEventDirectory: 'typeAheadForEventDirectory',
    selectedEventDirectoryFilters: 'selectedEventDirectoryFilters',
    disableEventDirectoryInfiniteScroll: 'disableEventDirectoryInfiniteScroll',
    nextEventDirectorySearchOffset: 'nextEventDirectorySearchOffset',
    eventDirectorySelectedLetterFilter: 'eventDirectorySelectedLetterFilter',

    // Ypo Events
    ypoEventsList: 'ypoEventsList',
    ypoEventsResultCount: 'ypoEventsResultCount',
    ypoEventsFacets: 'ypoEventsFacets',
    ypoEventsSort: 'ypoEventsSort',
    ypoEventsAppliedFilterPills: 'ypoEventsAppliedFilterPills',
    ypoEventsSelectedFilters: 'ypoEventsSelectedFilters',
    ypoEventsRegionsList: 'ypoEventsRegionsList',
    disableYpoEventsInfiniteScroll: 'disableYpoEventsInfiniteScroll',
    ypoEventResultOffset: 'ypoEventResultOffset',
    canFetchMoreResult: 'canFetchMoreResult',
    mobileFiltersActive: 'mobileFiltersActive',

    //Content Directory
    contentState: 'contentState',
    contentSelectedFilters: 'contentSelectedFilters',
    contentSearchText: 'contentSearchText',
    contentDirectorySort: 'contentDirectorySort',
    contentDirectorySelectedLetterFilter: 'contentDirectorySelectedLetterFilter',

    //Community Directory Results
    communityDirectorySearchResults: 'communityDirectorySearchResults',
    communityDirectorySort: 'communityDirectorySort',
    communityDirectorySearchText: 'communityDirectorySearchText',
    communityResultList: 'communityResultList',
    ribbonCommunityState: 'ribbonCommunityState',
    selectedCommunityDirectoryFilters: 'selectedCommunityDirectoryFilters',
    selectedCommunityTypeAhead: 'selectedCommunityTypeAhead',
    communityDirectoryResults: 'communityDirectoryResults',
    communityState: 'communityState',
    communitySelectedFilters: 'communitySelectedFilters',
    disableCommunityDirectoryInfiniteScroll: 'disableCommunityDirectoryInfiniteScroll',
    nextCommunityDirectorySearchOffset: 'nextCommunityDirectorySearchOffset',
    communityDirectorySelectedLetterFilter: 'communityDirectorySelectedLetterFilter',

    //Content Directory Results
    contentDirectorySearchResults: 'contentDirectorySearchResults',
    contentDirectorySearchText: 'contentDirectorySearchText',
    contentResultList: 'contentResultList',
    ribbonContentState: 'ribbonContentState',
    selectedContentDirectoryFilters: 'selectedContentDirectoryFilters',
    selectedContentTypeAhead: 'selectedContentTypeAhead',
    disableContentDirectoryInfiniteScroll: 'disableContentDirectoryInfiniteScroll',
    nextContentDirectorySearchOffset: 'nextContentDirectorySearchOffset',

    //Region Chapter List
    chapterList: 'chapterList',
    allChapterList: 'allChapterList',

    //sponsor module getters
    sponsorLists: 'sponsorLists',

    //my account action
    profileInformation: 'profileInformation',
    usernameResponse: 'usernameResponse',
    passwordResponse: 'passwordResponse',
    prospectsList: 'prospectsList',
    votes: 'votes',
    voted: 'voted',

    //Privacy Settings action
    notificationInformation: 'notificationInformation',
    visibilityInformation: 'visibilityInformation',
    emailInformation: 'emailInformation',
    emailPreferencesResponse: 'emailPreferencesResponse',

    getCATools: 'getCATools',
    getOverallChapterHealth: 'getOverallChapterHealth',
    getOverallChapterHealthData: 'getOverallChapterHealthData',
    chapterHealthReport: 'chapterHealthReport',
    getOverallChapterHealthScore: 'getOverallChapterHealthScore',

    //files And media
    filesAndMediaList: 'filesAndMediaList',
    chapterAdminForumManagement: 'chapterAdminForumManagement',
    chapterOfficerManagemet: 'chapterOfficerManagemet',
    chapterAdminProspectManagement: 'chapterAdminProspectManagement',
    chapterAdminProspectsReadyToPay: 'chapterAdminProspectsReadyToPay',
    canReorder: 'canReorder',
    canView: 'canView',
    fileUploadPercentage: 'fileUploadPercentage',
    //files and folders Download
    downloadFiles: 'downloadFiles',
    downloadFolders: 'downloadFolders',
    //end

    //Tools getters
    resourceLinks: 'resourceLinks',
    myQuickLinks: 'myQuickLinks',
    shareYourIdeasLinks: 'shareYourIdeasLinks',

    //YpoError
    ypoErrorData: 'ypoErrorData',

    //News Feed
    newsFeed: 'newsFeed',

    //Member profile getters
    ypoAwardsInformation: 'ypoAwardsInformation',
    biographyInformation: 'biographyInformation',
    trainingAndCertifications: 'trainingAndCertifications',
    accomplishments: 'accomplishments',
    professionalRoles: 'professionalRoles',
    companyInvestments: 'companyInvestments',
    familyInterests: 'familyInterests',
    familyDetails: 'familyDetails',
    isAboutMeVisible: 'isAboutMeVisible',
    isYpoCommunitiesVisible: 'isYpoCommunitiesVisible',
    isProfessionalExperienceVisible: 'isProfessionalExperienceVisible',
    educationDetails: 'educationDetails',
    contactInformation: 'contactInformation',
    networkChapters: 'networkChapters',
    networkRegions: 'networkRegions',
    networks: 'networks',
    communities: 'communities',
    events: 'events',
    myActivity: 'myActivity',
    currentUserId: 'currentUserId',
    isPMTeamMember: 'isPMTeamMember',
    professionalExperience: 'professionalExperience',
    isFormerMember: 'isFormerMember',
    profileConnection: 'profileConnection',
    profileFollowing: 'profileFollowing',
    profileImage: 'profileImage',
    fallBackLoggedInProfileImageUrl: 'fallBackLoggedInProfileImageUrl',
    communitiesGroup: 'communitiesGroup',
    assetSummaryShortcut: 'assetSummaryShortcut',
    assetSummary: 'assetSummary',
    countryAndRegions: 'countryAndRegions',
    pendingAssets: 'pendingAssets',
    championPositions: 'championPositions',
    quickLinks: 'quickLinks',
    quickLinks2: 'quickLinks2',
    categoryLink: 'categoryLink',
    categoryMaster: 'categoryMaster',
    categoryType: 'categoryType',
    profileDropDowns: 'profileDropDowns',
    userProfileImageExists: 'userProfileImageExists',
    canUserImpersonate: 'canUserImpersonate',

    //Edit Profile getters
    editEducationResponse: 'editEducationResponse',
    saveEducationResponse: 'saveEducationResponse',
    deleteEducationResponse: 'deleteEducationResponse',
    schoolTypes: 'schoolTypes',
    degreeTypes: 'degreeTypes',
    educationSearchResult: 'educationSearchResult',
    industory: 'industory',
    externalConnectionIndustry: 'externalConnectionIndustry',
    prospectDownloadInProgress: 'prospectDownloadInProgress',
    getIsCommunityAdmin: 'getIsCommunityAdmin',
    getIsCommunityModerated: 'getIsCommunityModerated',
    getCommunitySalesforceId: 'getCommunitySalesforceId',
    getChapterHealthScore: 'getChapterHealthScore',
    presidentTypes: 'presidentTypes',
    companyTypes: 'companyTypes',
    companySizes: 'companySizes',
    businessScopes: 'businessScopes',
    countryAndStates: 'countryAndStates',
    familyInterestTypes: 'familyInterestTypes',
    editProfessionalExperienceResponse: 'editProfessionalExperienceResponse',
    saveProfessionalExperienceResponse: 'saveProfessionalExperienceResponse',
    deleteProfessionalExperienceResponse: 'deleteProfessionalExperienceResponse',
    professionalExperienceSearchResults: 'professionalExperienceSearchResults',
    businessInterestTypes: 'businessInterestTypes',
    relationshipStatusTypes: 'relationshipStatusTypes',
    updatePersonExternalResponse: 'updatePersonExternalResponse',
    savePersonExternalResponse: 'savePersonExternalResponse',
    deletePersonExternalResponse: 'deletePersonExternalResponse',
    spousePartnerAccessTypes: 'spousePartnerAccessTypes',
    emergencyContactRelationTypes: 'emergencyContactRelationTypes',
    profilePhoto: 'profilePhoto',
    wizards: 'wizards',
    getModeratedPostCreated: 'getModeratedPostCreated',
    addressTypes: 'addressTypes',
    socialNetworkTypes: 'socialNetworkTypes',
    vCardDetails: 'vCardDetails',
    isFamilyInterestsLoading: 'isFamilyInterestsLoading',
    searchProfile: 'searchProfile',
    togglePendingAssetRequests: 'togglePendingAssetRequests',

    //ChapterAdmin
    chapterAdmin: 'chapterAdmin',

    //Notification getters
    fcmToken: 'fcmToken',

    //forum ToolKit
    forumToolKitList: 'forumToolKitList',
    forumToolKitListContent: 'forumToolKitListContent',
    forumToolKitListExercise: 'forumToolKitListExercise',
    forumSampleandAgendas: 'forumSampleandAgendas',
    forumQuickLinks: 'forumQuickLinks',
    forumObjectState: 'forumObjectState',

    //Network Related Communities
    relatedCommunitiesList: 'relatedCommunitiesList',
    getRequestedMembers: 'getRequestedMembers',
    getRequestedGroups: 'getRequestedGroups',
    getInviteSomeOne: 'getInviteSomeOne',
    getManageParticipants: 'getManageParticipants',
    getConfigureGroup: 'getConfigureGroup',
    getNewGroupRequest: 'getNewGroupRequest',
    relatedCommunitiesList_canEdit: 'relatedCommunitiesList_canEdit',
    updateRelatedCommuinty: 'updateRelatedCommuinty',
    subNetworkList: 'subNetworkList',
    requestedJoineeList: 'requestedJoineeList',
    resultApproveRequest: 'resultApproveRequest',
    inviteeList: 'inviteeList',
    joinNetwork: 'joinNetwork',
    ypoNetworks: 'ypoNetworks',
    returnInviteesList: 'returnInviteesList',
    communityAdminList: 'communityAdminList',
    verifiedMembers: 'verifiedMembers',
    getSelectedPostType: 'getSelectedPostType',
    allPrefixes: 'allPrefixes',
    allSuffixes: 'allSuffixes',
    isRelationshipStatus: 'isRelationshipStatus',
    getSelectedNetwork: 'getSelectedNetwork',
    communityPendingRequests: 'communityPendingRequests',
    allNetworks: 'allNetworks',
    viewPendingAssetRequest: 'viewPendingAssetRequest',
    streetAddress: 'streetAddress',
    networkPageContent: 'networkPageContent',

    // Messenger
    conversations: 'conversations',
    messengerSessionState: 'messengerSessionState',
    messengerUsername: 'messengerUsername',
    chatParticipantProfiles: 'chatParticipantProfiles',
    globalChatNotificationCount: 'globalChatNotificationCount',

    // Recommended Events
    recommendedEvents: 'recommendedEvents',
    recommendedMembers: 'recommendedMembers',
    reasonsToConnect: 'reasonsToConnect',
    canEditRelatedCommunities: 'canEditRelatedCommunities',

    // Renewals
    renewalStatus: 'renewalStatus',

    //Forum Meetings
    forumMeetings: 'forumMeetings',

    //AssistPage
    assistPageTopics: 'assistPageTopics',
    canEditAssistPage: 'canEditAssistPage',
    newAndComingSoonUploadStatus: 'newAndComingSoonUploadStatus',
    canAssistUserEdit: 'canAssistUserEdit',
    releaseNotes: 'releaseNotes',

    //Feedback Form
    feedbackQuestions: 'feedbackQuestions',
    submittedFeedback: 'submittedFeedback',
    takeTourVideos: 'takeTourVideos',
    newsAndComingSoonFiles: 'newsAndComingSoonFiles',
    recentReleasesFiles: 'recentReleasesFiles',
    comingSoonFiles: 'comingSoonFiles',
    canEditTakeTourVideos: 'canEditTakeTourVideos',
    videoUploadPercentage: 'videoUploadPercentage',

    //speaker Registeration form
    memberAssociationList: 'memberAssociationList',
    languagesList: 'languagesList',
    topicsList: 'topicsList',
    feeRangeList: 'feeRangeList',
    memberProfileDetails: 'memberProfileDetails',
    pendingApplicants: 'pendingApplicants',
    pendingApplicantsCount: 'pendingApplicantsCount',
    reviewedApplicants: 'reviewedApplicants',
    speakerRegistrationStatus: 'speakerRegistrationStatus',
    disablePAInfiniteScroll: 'disablePAInfiniteScroll',
    countryList: 'countryList',
    regionListForCFF: 'regionListForCFF',
    regionListForCFFNames: 'regionListForCFFNames',
    maxFeesRange: 'maxFeesRange',
    minFeesRange: 'minFeesRange',

    //Chapter Waiver
    printWaiverDetails: 'printWaiverDetails',
    waiverTypes: 'waiverTypes',
    listOfWaivers: 'listOfWaivers',
    visibleProspect: 'visibleProspect',
    waiverQuestions: 'waiverQuestions',
    waiverDetails: 'waiverDetails',
    chapterMemberCount: 'chapterMemberCount',
    prpRole: 'prpRole',
    nextWaiverListPageNumber: 'nextWaiverListPageNumber',
    noMoreWaiverListToFetch: 'noMoreWaiverListToFetch',
    disableWaiverListInfiniteScroll: 'disableWaiverListInfiniteScroll',
    waiverSentBackToChapter: 'waiverSentBackToChapter',
    sentBackErrorOccurred: 'sentBackErrorOccurred',
    completeWaiverDetails: 'completeWaiverDetails',
    prpMemberList: 'prpMemberList',
    regionalCommentsErrorOccurred: 'regionalCommentsErrorOccurred',
    regionalCommentSaved: 'regionalCommentSaved',
    memberVoteStatus: 'memberVoteStatus',
    voteStatusError: 'voteStatusError',
    finalizeEmailRecipients: 'finalizeEmailRecipients',
    waiverAttachmentSaved: 'waiverAttachmentSaved',
    finalizeError: 'finalizeError',
    searchResults: 'searchResults',
    chunkedSearchResults: 'chunkedSearchResults',
    corporationTypes: 'corporationTypes',
    titleTypes: 'titleTypes',
    isPRPAdmin: 'isPRPAdmin',
    isPRPMember: 'isPRPMember',
    isActive: 'isActive',

    //Businesses Page
    searchedAssets: 'searchedAssets',
    showAssetId: 'showAssetId',
    businessCommunityId: 'businessCommunityId',
    noMorePendingApplicantsToFetch: 'noMorePendingApplicantsToFetch',
    disableRAInfiniteScroll: 'disableRAInfiniteScroll',
    noMoreReviewedApplicantsToFetch: 'noMoreReviewedApplicantsToFetch',
    isBecomeASpeaker: 'isBecomeASpeaker',
    YPOSpeakers: 'YPOSpeakers',
    rejectApplicant: 'rejectApplicant',
    approveApplicant: 'approveApplicant',
    speakerProfile: 'speakerProfile',
    isSpeakerApproved: 'isSpeakerApproved',
    canViewSpeakerAdminDirectory: 'canViewSpeakerAdminDirectory',

    //Login-in External Speaker
    isExternalSpeaker: 'isExternalSpeaker',
    isSpeakerView: 'isSpeakerView',
    prevRouteUrlName: 'prevRouteUrlName',
    speakerStatus: 'speakerStatus',
    scrollPendingApplicantToViewMember: 'scrollPendingApplicantToViewMember',
    speakerUserProfile: 'speakerUserProfile',

    //event attendees - whos coming
    eventAttendees: 'eventAttendees',
    uploadError: 'uploadError',

    //PoliciesProcedures
    policiesHeadings: 'policiesHeadings',
    articleData: 'articleData',

    //Create Event
    timeZones: 'timeZones',
    isSubmitChapterEvent: 'isSubmitChapterEvent',
    eventCustomField: 'eventCustomField',
    cventLookup: 'cventLookup',

    //Champs Page
    activeComponentPropsForInlineLoader: 'activeComponentPropsForInlineLoader',
    chapterHealthPoints: 'chapterHealthPoints',
    emailSenderList: 'emailSenderList',
    emailRecipients: 'emailRecipients',
    emailContent: 'emailContent',
    previewEmailContent: 'previewEmailContent',
    allEmailInformation: 'allEmailInformation',
    timeZonesForEmail: 'timeZonesForEmail',

    //Champs - Events
    createEvent: 'createEvent',
    chapterEvent: 'chapterEvent',
    communityUsers: 'communityUsers',
    eventInfo: 'eventInfo',
    eventCustomFields: 'eventCustomFields',
    launchEvent: 'launchEvent',
    nextBoardMeetingEvent: 'nextBoardMeetingEvent',

    //Ypo Common Components
    chapterChairMessage: 'chapterChairMessage',
    chapterAnnouncement: 'chapterAnnouncement',
    chapterSponsorLists: 'chapterSponsorLists',
    chapterCanEditSponsor: 'chapterCanEditSponsor',
    chapterFilesAndMediaList: 'chapterFilesAndMediaList',
    chapterCanReorder: 'chapterCanReorder',
    chapterCanView: 'chapterCanView',
    chapterDownloadFiles: 'chapterDownloadFiles',
    chapterDownloadFolders: 'chapterDownloadFolders',
    reportDrillDownName: 'reportDrillDownName',
    announcement: 'announcement',
    eventsList: 'eventsList',
    membersList: 'membersList',

    //OpenAuth API
    termsPrivacyURLs: 'termsPrivacyURLs',
    unRegisteredEvents: 'unRegisteredEvents',
    cookiePolicyUrl: 'cookiePolicyUrl',

    // AuthSf
    sfAuthToken: 'sfAuthToken',

    //MFA Settings
    userMFASettings: 'userMFASettings',
    loginSecuritySettings: 'loginSecuritySettings',
    isUserInAmfaGroup: 'isUserInAmfaGroup',
    securityQuestionsList: 'securityQuestionsList',
    passwordComplexityRequirements: "passwordComplexityRequirements",
    userInfo: 'userInfo',
    getPhoneConfirmation: 'getPhoneConfirmation',

    //Connect Plus
    connectPlusRedirects: 'connectPlusRedirects',

    // Chapter Studio
    chapterStudioChapterList: 'chapterStudioChapterList',
    chapterStudioResources: 'chapterStudioResources',
    chapterStudioFavorites: 'chapterStudioFavorites',
    chapterStudioFavoriteResourceIds: 'chapterStudioFavoriteResourceIds',
    chapterStudioSelectedChapter: 'chapterStudioSelectedChapter',
    chapterStudioAnnouncements: 'chapterStudioAnnouncements',

    // Manage Chapter Studio
    manageChapterStudioAllAnnouncements: 'manageChapterStudioAllAnnouncements',
    manageChapterStudioPastAnnouncements: 'manageChapterStudioPastAnnouncements',
    manageChapterStudioBreadcrumbs: 'manageChapterStudioBreadcrumbs',
    chapterStudioPicklists: 'chapterStudioPicklists',
    announcementFromState: 'announcementFromState',
};
